<template>
  <v-parallax dark>
    <v-row align="center" justify="center">
      <v-col class="mb-12 text-center" cols="12">
        <GChart
          type="Timeline"
          :data="chartData"
          :options="chartOptions"
          :settings="{ packages: ['timeline'] }"
        />
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  components: { GChart },
  data() {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [
        ['Role', 'Name', 'Start', 'End'],
        ['President', 'John Adams', new Date(1800, 2, 4), new Date(1801, 6, 4)],
        [
          'President',
          'Thomas Jefferson',
          new Date(1801, 2, 4),
          new Date(1809, 2, 4),
        ],
        [
          'President',
          'George Washington',
          new Date(1790, 3, 30),
          new Date(1797, 2, 4),
        ],
      ],
      chartOptions: {
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit:2014-2017',
        },
      },
    };
  },
};
</script>

<style></style>
